// DocumentosPresentados.js — Merge JCUMAS 060.013
import React, { useEffect, useState } from "react";
import { Table, Button, Spinner, Container, Form, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Components/Header";
import 'bootstrap-icons/font/bootstrap-icons.css';

const BASE_URL = process.env.REACT_APP_API_URL;

const DocumentosPresentados = () => {
  const [documentos, setDocumentos] = useState([]);
  const [loadingDocumentos, setLoadingDocumentos] = useState(true);
  const [descargando, setDescargando] = useState(null); // id del doc en descarga
  const [filtroDoc, setFiltroDoc] = useState("");
  const userId = localStorage.getItem("id");

  useEffect(() => {
    const fetchDocumentos = async () => {
      setLoadingDocumentos(true);
      try {
        const response = await fetch(
          `${BASE_URL}/documentos/usuario/${userId}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setDocumentos(data);
        } else {
          console.error("Error al obtener documentos");
        }
      } catch (error) {
        console.error("Error al hacer la solicitud:", error);
      } finally {
        setLoadingDocumentos(false);
      }
    };

    fetchDocumentos();
  }, []);

  // Descarga llamando al endpoint dedicado — sin base64 en memoria
  const handleDownload = async (documentoId, nombreDocumento) => {
    setDescargando(documentoId);
    try {
      const response = await fetch(
        `${BASE_URL}/documentos/${documentoId}/download`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (!response.ok) throw new Error("Error al descargar el documento");

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombreDocumento || "documento.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("No se pudo descargar el documento.");
    } finally {
      setDescargando(null);
    }
  };

  return (
    <div className="d-flex flex-column">
      <Header />
      <main className="flex-grow-1">
        <Container fluid className="py-3 px-4">
          <h4 className="section-title mb-2 mt-2">
            <i className="bi bi-file-earmark-text me-2 text-primary"></i>
            Documentos presentados
          </h4>
          <p className="text-muted mb-4">
            En esta sección puede consultar y descargar todos los documentos
            que haya presentado a través de la oficina virtual.
          </p>

          {loadingDocumentos ? (
            <div className="text-center py-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
              <p className="mt-3 mb-0">Cargando documentos...</p>
            </div>
          ) : (
            <div>
              {documentos.length === 0 ? (
                <p className="text-center text-muted py-4">
                  No ha presentado ningún documento.
                </p>
              ) : (
                <>
                  <InputGroup className="mb-3">
                    <InputGroup.Text><i className="bi bi-search"></i></InputGroup.Text>
                    <Form.Control
                      placeholder="Buscar por nombre de documento…"
                      value={filtroDoc}
                      onChange={(e) => setFiltroDoc(e.target.value)}
                    />
                    {filtroDoc && (
                      <Button variant="outline-secondary" onClick={() => setFiltroDoc("")}>✕</Button>
                    )}
                  </InputGroup>

                <Table hover responsive className="mb-2 align-middle">
                    <thead className="thead-brand thead-label">
                      <tr>
                        <th>Nombre de documento</th>
                        <th style={{ width: "220px" }}>Fecha de subida</th>
                        <th className="text-center" style={{ width: "150px" }}>
                          Descarga
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {documentos
                        .filter((doc) =>
                          doc.NombreDocumento?.toLowerCase().includes(filtroDoc.toLowerCase())
                        )
                        .map((doc) => (
                        <tr key={doc.DocumentoID}>
                          <td className="text-muted">{doc.NombreDocumento}</td>
                          <td>
                            {new Date(doc.FechaSubida).toLocaleDateString(
                              "es-ES",
                              { year: "numeric", month: "long", day: "numeric" }
                            )}
                          </td>
                          <td className="text-end">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              disabled={descargando === doc.DocumentoID}
                              onClick={() =>
                                handleDownload(doc.DocumentoID, doc.NombreDocumento)
                              }
                            >
                              {descargando === doc.DocumentoID ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <><i className="bi bi-download me-1" />Descargar</>
                              )}
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
                </>
              )}
            </div>
          )}
        </Container>
      </main>
    </div>
  );
};

export default DocumentosPresentados;